var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.status !== '')?_c('span',{staticClass:"kiwi-typingstatusindicator",class:{ 'kiwi-typingstatusindicator--paused': _vm.status === 'paused' }},[_vm._v("…")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f9736d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customized-core/TypingStatusIndicator.vue
// module id = QiR4
// module chunks = 1